import React from "react";
import AcknowledgmentModal from "./AcknowledgmentModal";

export default function PrivacyAcknowledgmentModal({ onConfirm }) {
  return (
    <AcknowledgmentModal
      title="COPLINE CONFIDENTIALITY ACKNOWLEDGMENT"
      checkboxLabel="I acknowledge and agree"
      confirmBtnText="Continue"
      onConfirm={onConfirm}
    >
      <p style={{ marginBottom: "1rem" }}>
        CopLine calls are confidential. Confidentiality will be breached for:
      </p>
      <ul style={{ paddingLeft: "1.5rem", marginBottom: "1rem" }}>
        <li>suspected child abuse, neglect, or endangerment</li>
        <li>suspected elder abuse, neglect, or endangerment</li>
        <li>a credible threat of homicide</li>
      </ul>
      <p>Please confirm you understand and agree to follow this policy.</p>
    </AcknowledgmentModal>
  );
}
